"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var assets_shared_service_1 = require("./assets-shared.service");
var api_config_1 = require("../api.config");
var browser_1 = require("file-type/browser");
var models_1 = require("../models");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../api.config");
var AssetFilesService = /** @class */ (function () {
    function AssetFilesService(http, httpClient, config) {
        this.http = http;
        this.httpClient = httpClient;
        this.config = config;
        this.appName = "assets-api";
        this.config = config;
    }
    AssetFilesService.prototype.AmendDocumentFileAsync = function (id, amendDocumentFileRequest) {
        var body = JSON.stringify(amendDocumentFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/modifyDocument", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.AmendImageFileAsync = function (id, amendImageFileRequest) {
        var body = JSON.stringify(amendImageFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/modifyImage", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.AmendVideoFileAsync = function (id, amendVideoFileRequest) {
        var body = JSON.stringify(amendVideoFileRequest);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/modifyVideo", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.CreateAssetLinkAsync = function (id, request) {
        var body = JSON.stringify(request);
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/redirect", body)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.CreateNewVersionAsync = function (id, createdByProfileId) {
        var params = new http_1.HttpParams();
        if (createdByProfileId) {
            params = params.set('createdByProfileId', createdByProfileId.toString());
        }
        ;
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/createNewVersion", null, { params: params })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.DisableAsync = function (id, modifiedByProfileId) {
        var params = new http_1.HttpParams();
        if (modifiedByProfileId) {
            params = params.set('modifiedByProfileId', modifiedByProfileId.toString());
        }
        ;
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/disable", null, { params: params })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.EnableAsync = function (id, modifiedByProfileId) {
        var params = new http_1.HttpParams();
        if (modifiedByProfileId) {
            params = params.set('modifiedByProfileId', modifiedByProfileId.toString());
        }
        ;
        return this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/enable", null, { params: params })
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.GetAsync = function (id) {
        return this.http.get(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id)
            .pipe(operators_1.catchError(assets_shared_service_1.AssetsSharedService.handleError()));
    };
    AssetFilesService.prototype.UploadSuccessAsync = function (id, fileSizeInBytes, mimeType, fileName, modifiedByProfileId) {
        var params = new http_1.HttpParams();
        if (fileSizeInBytes) {
            params = params.set('fileSizeInBytes', fileSizeInBytes.toString());
        }
        if (mimeType) {
            params = params.set('mimeType', mimeType);
        }
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        if (fileName) {
            params = params.set('fileName', fileName.replace("&", "_"));
        }
        if (modifiedByProfileId) {
            params = params.set('modifiedByProfileId', modifiedByProfileId.toString());
        }
        var responseSubject = new rxjs_1.Subject();
        this.http.put(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/uploaded", null, { params: params })
            .subscribe(function (result) {
            responseSubject.next(result);
        }, function (error) {
            responseSubject.error(error.error);
        });
        return responseSubject;
    };
    AssetFilesService.prototype.UploadAsync = function (id, modifiedByProfileId, file) {
        var _this = this;
        var params = new http_1.HttpParams();
        if (modifiedByProfileId) {
            params = params.set('modifiedByProfileId', modifiedByProfileId.toString());
        }
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        if (file) {
            params = params.set('mimeType', file.type);
            params = params.set('fileName', file.name.replace("&", "_"));
        }
        var responseSubject = new rxjs_1.Subject();
        this.http
            .get(this.config.AssetsApiEndpoint + "/api/assetfiles/" + id + "/uploadUrl", { params: params })
            .subscribe(function (presignedUrl) {
            if (presignedUrl && presignedUrl.url.length > 0) {
                _this.BucketUploadAsync(id, presignedUrl, file)
                    .subscribe(function (res) {
                    if (res.status == 200) {
                        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
                        _this.UploadSuccessAsync(id, file.size, file.type, file.name.replace("&", "_"), modifiedByProfileId)
                            .subscribe(function (assetFile) {
                            if (assetFile) {
                                // set the asset set id and new version number - so that reaction events can be aware of the specifically newly uploaded file
                                res.assetSetId = assetFile.assetSetId;
                                res.uploadedVersion = assetFile.versionCurrent.assetFile;
                                responseSubject.next(res);
                            }
                        }, function (error) {
                            responseSubject.error(error);
                        });
                    }
                    else if (res.status == null && res.progress > 0) {
                        responseSubject.next(res);
                    }
                    else if (res instanceof http_1.HttpErrorResponse) {
                        responseSubject.error("Backend returned code " + res.status + ", body was: " + res.error + ", message was: " + res.message);
                    }
                }, function (error) {
                    responseSubject.error(error);
                });
            }
            else {
                responseSubject.error("Failed when obtaining the presigned url: " + JSON.stringify(presignedUrl));
            }
        }, (function (error) {
            responseSubject.error(error);
        }));
        return responseSubject;
    };
    AssetFilesService.prototype.BucketUploadAsync = function (id, presignedUrl, file) {
        var input = new File([file], null);
        var responseSubject = new rxjs_1.Subject();
        responseSubject.next({ fileId: id, progress: 0, status: 1 });
        // Note that if content type is specified when generating the Amazon S3 presigned Url,
        // it should also be included in the HttpRequest headers of the eventual upload request, otherwise a signature error may result.
        var headers = new http_1.HttpHeaders();
        if (presignedUrl.contentType) {
            // workaround to set headers until they fix the httpclient https://github.com/angular/angular/issues/19044
            headers = headers.set('Content-Type', presignedUrl.contentType);
            // https://angular.io/guide/service-worker-devops
            headers = headers.set("ngsw-bypass", "");
            // headers.set('Content-Type', presignedUrl.contentType);
        }
        // Look for upload progress events in the raw event stream
        this.httpClient.put("" + presignedUrl.url, input, { headers: headers, reportProgress: true, responseType: 'text', observe: 'events' }).subscribe(function (event) {
            if (event.type === http_1.HttpEventType.UploadProgress && event.type > 0) {
                // Calculate % done:
                var percentDone = Math.round(100 * event.loaded / event.total);
                responseSubject.next({ fileId: id, progress: percentDone, status: null });
            }
            else if (event instanceof http_1.HttpResponse && event.status == 200 && event.type > 0) {
                responseSubject.next({ fileId: id, progress: 100, status: event.status });
            }
            else if (event instanceof http_1.HttpErrorResponse) {
                if (event.error instanceof models_1.Error) {
                    // Handle client-side or network error.
                    throw rxjs_1.throwError('An error occurred:' + event.message);
                }
                else {
                    // Handle backend unsuccessful response code.
                    throw rxjs_1.throwError("Backend returned code " + event.status + ", body was: " + event.error + " " + JSON.stringify(event));
                }
            }
            else if (event instanceof http_1.HttpHeaderResponse && event.status != 200) {
                // Handle backend unsuccessful response code.
                throw rxjs_1.throwError("Backend returned code " + event.status + ", body was: " + event.statusText);
            }
        });
        return responseSubject;
    };
    AssetFilesService.prototype.GetMimeTypeForFile = function (file) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        return rxjs_1.Observable.create(function (observer) {
            reader.onload = (function (e) {
                var stream = e.target.result;
                observer.next(stream);
            });
        }).pipe(operators_1.switchMap(function (stream) {
            return rxjs_1.from(browser_1.fromBuffer(stream));
        }));
    };
    AssetFilesService.ngInjectableDef = i0.defineInjectable({ factory: function AssetFilesService_Factory() { return new AssetFilesService(i0.inject(i1.HttpClient), i0.inject(i1.HttpClient), i0.inject(i2.API_CONFIG)); }, token: AssetFilesService, providedIn: "root" });
    AssetFilesService = __decorate([ __param(2, core_1.Inject(api_config_1.API_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, http_1.HttpClient, Object])
    ], AssetFilesService);
AssetFilesService.ɵfac = function AssetFilesService_Factory(t) { return new (t || AssetFilesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(api_config_1.API_CONFIG)); };
AssetFilesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AssetFilesService, factory: function (t) { return AssetFilesService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetFilesService, [{
        type: core_1.Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [api_config_1.API_CONFIG]
            }] }]; }, null); })();
    return AssetFilesService;
}());
exports.AssetFilesService = AssetFilesService;

